enum Currencies {
  USD = "usd",
  EUR = "eur",
  GBP = "gbp",
  AUD = "aud",
  CAD = "cad",
  NZD = "nzd",
  CHF = "chf",
  SEK = "sek",
  DKK = "dkk",
  NOK = "nok",
}

export default Currencies;
